import { AvatarDesignTokens } from '@primeuix/themes/types/avatar';

export const AVATAR_STYLES: AvatarDesignTokens = {
  root: {
    background: '{primary.50}',
    color: '{primary.600}',
    fontSize: '0.875rem',
    height: '2.5rem',
    width: '2.5rem',
  },
  css: ({ dt }) => `
    .p-avatar {
      border: 1px solid ${dt('primary.600')};
      flex-shrink: 0;
      line-height: 1.25rem;
      font-weight: 500;
    }

    .p-avatar img {
      object-fit: cover;
    }`,
};
